module.exports = __webpack_public_path__ + "static/media/case2A.f5b6b4a.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case2A.mp4
// module id = MYmc
// module chunks = 0